module.exports = __webpack_public_path__ + "static/img/third1_1_active.292af6c1.png";